export default __webpack_public_path__ + "static/cheer-bottles-square-72691847e300ea2a492934d4843b6abd.png";